export default __webpack_public_path__ + "static/media/unitil-logo.a27fe496.png";